import {Component, OnInit, OnDestroy} from '@angular/core';
import {BaseListComponent} from '../../../abstract/base-list.component';
import {ErrorConstants} from '../../../shared/constants/error-constants';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {AppConstants} from '../../../shared/constants/app-constants';
import {ResponseWrapper} from '../../../data/model/APiWrapper/response-wrapper';
import {PaypalCaptures} from '../../../data/model/PaypalCaptures/paypal-captures.model';
import {DataManagerService} from '../../../data/services/DataManager/data-manager.service';
import {Highlight} from '../../../shared/highlights/highlight';
import {Subject} from 'rxjs';
import {ExportModel} from '../../../data/model/ExportModel/export-model';
import {ExportConstants} from '../../../shared/constants/export-constants';
import {debounceTime} from 'rxjs/operators';

@Component({
    selector: 'app-paypal-transactions',
    templateUrl: './paypal-transactions.component.html',
    styleUrls: ['./paypal-transactions.component.css'],
    standalone: false
})
export class PaypalTransactionsComponent extends BaseListComponent implements OnInit, OnDestroy {
  _router: Router;
  showExport = false;
  exportData: object;
  from_date: any;
  to_date: any;
  excel = 1;
  exportExcel: ExportModel[] = ExportConstants.paypalTransactionExport;
  transactionsList: ResponseWrapper<PaypalCaptures>;
  apiEndpointUrl = 'paypal/transactions';
  appUrl = 'payment/paypal-transactions';
  today: Date = new Date();

  constructor(router: Router, private datePipe: DatePipe, dataManager: DataManagerService) {
    super();

    this.exportData = {
      exportServiceName: '/paypal/export-transactions',
      redirectUrl: '/' + this.appUrl,
      cancelRedirectUrl: '/' + this.appUrl,
      fileName: 'Paypal_Transactions_Report',
      heading: 'Paypal Transactions'
    };

    this._router = router;
    this.router = router;
    this.searchHits = new Subject<void>();
    this.dataManager = dataManager;
    this.getListUrl = AppConstants.BASE_URL + '/' + this.apiEndpointUrl;
    this.setUrl();
  }

  ngOnInit(): void {
    this.searchHits.pipe(debounceTime(600), ).subscribe((res) => {
      if (!this.isNullOrUndefined(this.searchText) && this.searchText.length > 2) {
        this.setUrl();
      }
    });
  }

  paginate(paginateExtension) {
    this.getList(paginateExtension);
    this.loadFlag = true;
  }

  protected getListRes(res) {
    this.loadFlag = false;
    this.transactionsList = res;
    this.metadata = res.meta.pagination;
    if (res.data.length === 0) {
      this.errorMsg = ErrorConstants.paymentErrorMsg[0];
    } else {
      this.errorMsg = null;
    }
  }

  protected getListErr(error) {
    this.errorMsg = this.networkErrorHandler(error.error, ErrorConstants.paymentErrorMsg);

    this.loadFlag = false;
  }

  checkdate() {
    if (!this.isNull(this.from_date) && this.from_date.toString() === 'Invalid Date') {
      this.datereport();
    }
  }

  checkdate2() {

    if (!this.isNull(this.to_date) && this.to_date.toString() === 'Invalid Date') {
      this.datereport();
    }
  }

  datereport() {
    if ((this.from_date && this.from_date.toString() === 'Invalid Date') || (this.to_date && this.to_date.toString() === 'Invalid Date')) {
      this.showSnackBar('Enter valid date.', 'Ok', 3000);
    } else if ((this.isNullOrUndefined(this.from_date)) || this.isNullOrUndefined(this.to_date)) {
      if ((!this.isNullOrUndefined(this.searchText) && (this.isNull(this.from_date) && this.isNull(this.to_date)))
        || (this.isNullOrUndefined(this.searchText) && (this.isNull(this.from_date) && this.isNull(this.to_date)))) {
        this.from = this.formatDate(this.from);

        this.to = (this.isNullOrUndefined(this.to_date) ? '' : (this.datePipe.transform(this.to_date, 'yyyy-MM-dd')));
        this.to = this.formatDate(this.to);
        this.setUrl();

      } else {
        return;
      }
    } else if (this.from_date > this.to_date) {
      this.showSnackBar('From date should not exceed ' + this.datePipe.transform(this.to_date, 'MM/dd/yyyy') + '.', 'Ok', 3000);
    } else {
      this.from = (this.isNullOrUndefined(this.from_date) ? '' : (this.datePipe.transform(this.from_date, 'yyyy-MM-dd')));
      this.to = (this.isNullOrUndefined(this.to_date) ? '' : (this.datePipe.transform(this.to_date, 'yyyy-MM-dd')));
      this.from = this.formatDate(this.from);

      this.to = (this.isNullOrUndefined(this.to_date) ? '' : (this.datePipe.transform(this.to_date, 'yyyy-MM-dd')));
      this.to = this.formatDate(this.to);
      this.setUrl();
    }
  }

  highlight(value) {
    return Highlight.highlight(value, this.searchText);
  }

  openexcel(): void {
    this.showExport = true;
  }

  formatDate(date: string): string {
    return new Date(date).toISOString().split('T')[0];
  }

  redirectToDetails() {
    return '/payment/paypal-transaction-details';
  }
}
